export const web2_form = {
    "title": "",
    "edit_length": "",
    "era": "",
    "explicit": "",
    "public_domain": "",
    "cue_type": "",
    "has_vocals": "",
    "tempo": "",
    "bpm": "",
    "artiste": "",
    "composer": "",
    "description": "",
    "moods": "",
    "instrument_type": "",
    "production_type": "",
    "style_of": "",
    "catch_all": "",
    "writer_first_name": "",
    "writer_last_name": "",
    "writer_PRO_affiliation": "",
    "IPI_number": "",
    "writer_ownership_share": "",
    "licence": ""
};

export const web3_form = {
    name: "",
    collection: "",
    description: "",
}